import { useEffect, useState } from 'react';
import FloatConfigContainer from '../FloatConfigContainer/FloatConfigContainer';
import FloatConfigHeader from '../FloatConfigContainer/FloatConfigHeader/FloatConfigHeader';
import FloatConfigOption from '../FloatConfigContainer/FloatConfigOption/FloatConfigOption';
import { ConfigOption } from 'services/types';

const Collar = () => {
  // const handleClickOption = (id: string) => {
  //   // puzzle.puzzles.changeFabric(id);
  //   const procedures = getProcedures();
  //   if (procedures) {
  //     procedures.changeCollar(id);
  //   }
  // };
  const [collars, setCollars] = useState<ConfigOption[]>();
  useEffect(() => {
    fetch('data/collars.json')
      .then((response) => response.json())
      .then((data) => {
        setCollars(data);
      })
      .catch((error) => {
        console.error('Error fetching collars:', error);
      });
  }, []);

  return (
    <FloatConfigContainer>
      <FloatConfigHeader />
      <div className="body">
        <div className="list-container">
          {collars && collars.length > 0 && collars.map((clr, index) => (
            <FloatConfigOption
              key={clr.id}
              item={clr}
              procedure="changeCollar"
              type="collar"
            />
            // <div
            //   key={clr.id}
            //   onClick={() => handleClickOption(clr.id)}
            //   className="option-item"
            // >
            //   <div className="option-container">
            //     <div className="image">
            //       <img src={clr.img} alt="" />
            //     </div>
            //     <div className="item-info">
            //       <div className="left">
            //         <div className="name">{clr.name}</div>
            //         <div className="details">{clr?.details}</div>
            //       </div>
            //       <div className="right">{clr?.price}</div>
            //     </div>
            //   </div>
            // </div>
          ))}
        </div>
      </div>
    </FloatConfigContainer>
  );
};

export default Collar;
